import AT from './ActionTypes';
import * as api from '../api/apis';

export const updateUserProfileAccount = (
  account: any,
  userId: any,
  successCallback: any,
  errorCallback: any
) => {
  return (dispatch: any) => {
    api
      //@ts-expect-error: FIXME
      .updateUserProfile(account, userId)
      .then((resp) => {
        successCallback(resp, account);
      })
      .catch((error) => {
        errorCallback(error.response);
        dispatch({
          type: AT.UPDATE_CURRENT_USER_FAILURE,
          payload: account,
        });
      });
  };
};

export const updateUserPassword = (
  account: any,
  successCallback: any,
  errorCallback: any
) => {
  return () => {
    api
      .updateUserPassword(account)
      .then((resp) => {
        if (resp.status === 200) {
          successCallback(resp);
        }
      })
      .catch((error) => {
        errorCallback(error.response);
      });
  };
};
